import React, {useState, useCallback, useEffect} from 'react';
import DivisionRoleConfigurator from '../DivisionRoleConfigurator/DivisionRoleConfigurator';
import DepartmentSelector from '../DepartmentSelector/DepartmentSelector';

const RoleAssignmentPanel = ({handleChangeFormData, data, toggleColumn}) => {
  const [selectedTab, setSelectedTab] = useState('');

  useEffect(() => setSelectedTab(Object.keys(data)[0]), []);
  const handleToggleTab = useCallback((uuid) => {
    setSelectedTab(uuid);
  }, []);

  return (
    <div className='role-assignment-panel'>
      <DepartmentSelector
        data={data}
        selectedTab={selectedTab}
        handleToggleTab={handleToggleTab}
      />
      <DivisionRoleConfigurator
        handleChangeFormData={handleChangeFormData}
        data={data[selectedTab]}
        selectedTab={selectedTab}
        toggleColumn={toggleColumn}
      />
    </div>
  );
};

export default RoleAssignmentPanel;
